import { env } from 'src/configs/env'

export type displayDiscountTagAndEventProps = {
  discountPercentage?: number
  isAvailable?: boolean
}

type displayImageEventProps = {
  isAvailable: boolean
  originalPrice?: number
  discountPrice?: number
}

export const hasPromotionalEvent = (
  originalPrice?: number,
  discountPrice?: number
): boolean => originalPrice !== discountPrice

export const displayDiscountTagAndEvent = ({
  discountPercentage,
  isAvailable = undefined,
}: displayDiscountTagAndEventProps): boolean => {
  return (
    !!discountPercentage &&
    discountPercentage >= env.minimoPercentualDesconto &&
    !!isAvailable
  )
}

export const displayImageEvent = ({
  isAvailable,
  originalPrice,
  discountPrice,
}: displayImageEventProps) => {
  return isAvailable && hasPromotionalEvent(originalPrice, discountPrice)
}

export const displayPromotionalTag = (discountValue?: number): boolean =>
  !!discountValue && discountValue >= env.minimumDiscountPrice

// CA04/CA23: o selo de desconto e resolvido pelo BFF (price.show_discount_badge).
// A regra local abaixo e fallback para payload legado - nao a use quando o BFF mandou o valor.
export const resolveDiscountBadge = (
  showDiscountBadge: boolean | undefined,
  fallback: displayDiscountTagAndEventProps
): boolean => showDiscountBadge ?? displayDiscountTagAndEvent(fallback)

// Governa se o bloco do preco riscado renderiza no GProductOldPrice do DS - NAO e selo.
// Nao ligue em price.show_promo_badge: aquilo e "desconto absoluto >= R$100" e esconderia o "de".
export const hasPreviousPrice = (
  originalPrice?: number,
  discountPrice?: number
): boolean => (originalPrice ?? 0) > (discountPrice ?? 0)
